/**
 * Amendment.
 *
 * @author Warlock, AIS.PL
 */
export class Amendment {

  readonly name: string;

  readonly amount: number;

  /**
   * Converts JSON representation of amendment into {@link Amendment} instance.
   *
   * @param jsonObject JSON representation of purchase report
   */
  static fromJSON(jsonObject: any): Amendment {
    const result = Object.create(Amendment.prototype);
    return Object.assign(result, jsonObject, {
      amount: jsonObject.amount ? Number(jsonObject.amount) : null
    });
  }

}
